// extracted by mini-css-extract-plugin
export default {"root":"styles_root__D7kN6","tabNav":"styles_tabNav__G-77B","submitBtn":"styles_submitBtn__YHrjs","submitBtn_disable":"styles_submitBtn_disable__alcAD"};